import { Component, h, Prop, Watch } from '@stencil/core';

@Component({
  tag: 'ui-cms-download-search',
  styleUrl: 'ui-cms-download-search.css',
})
export class UiCmsDownloadSearch {
  @Prop({ mutable: true }) body: {
    searchApi: HTMLUiDownloadSearchElement['searchApi'];
    headline: HTMLUiDownloadSearchElement['headline'];
    resultsPerPage: HTMLUiDownloadSearchElement['resultsPerPage'];
    apiToken: HTMLUiDownloadSearchElement['apiToken'];
    suggestionsApi: HTMLUiDownloadSearchElement['suggestionsApi'];
    thumbnailBaseUrl: HTMLUiDownloadSearchElement['thumbnailBaseUrl'];
    facetsApi: HTMLUiDownloadSearchElement['facetsApi'];
    documentsInformationApi: HTMLUiDownloadSearchElement['documentsInformationApi'];
    quickFilters: { facet: string; title: string; categories: string[] }[];
  } = null;

  @Prop({ attribute: 'body' }) utilityBody: string;

  @Watch('utilityBody')
  utilityBodyChangeHandler(newValue) {
    this.body = newValue ? JSON.parse(newValue) : this.body;
  }

  componentWillLoad() {
    this.utilityBodyChangeHandler(this.utilityBody);
  }

  render() {
    return (
      <ui-download-search
        searchApi={this.body.searchApi}
        headline={this.body.headline}
        resultsPerPage={this.body.resultsPerPage}
        apiToken={this.body.apiToken}
        suggestionsApi={this.body.suggestionsApi}
        thumbnailBaseUrl={this.body.thumbnailBaseUrl}
        facetsApi={this.body.facetsApi}
        documentsInformationApi={this.body.documentsInformationApi}
      >
        {this.body.quickFilters?.map((filter) => (
          <ui-download-search-quickfilter values={JSON.stringify(filter.categories || [])} name={filter.facet}>
            {filter.title}
          </ui-download-search-quickfilter>
        ))}
      </ui-download-search>
    );
  }
}
